import { M as c, L as n, N as t, O as C, P as d, Q as i, R as x, S as u, X as o, T as j, U as h, V as v, W as f, Y as g, Z as m, _ as k, $ as y } from "./youtube-icon-CLMNT-5m.js";
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L = [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
], w = c("backpack", L);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M = [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
], p = c("calendar-range", M);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], H = c("chevrons-up-down", N);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const I = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], S = c("circle-alert", I);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
], B = c("circle-arrow-up", _);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const V = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
], A = c("circle-minus", V);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const F = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Z = c("circle-question-mark", F);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], z = c("ellipsis-vertical", b);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
], T = c("file-down", $);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const U = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
], D = c("file-plus", U);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P = [
  [
    "path",
    {
      d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
      key: "1oefj6"
    }
  ],
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
], R = c("file-up", P);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const q = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], O = c("globe", q);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const G = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "r6nss1"
    }
  ]
], W = c("house", G);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
], E = c("panel-left-close", X);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Q = [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
], J = c("power", Q);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K = [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
], Y = c("square-pen", K);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n1 = [
  ["path", { d: "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5", key: "slp6dd" }],
  [
    "path",
    {
      d: "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
      key: "o0xfot"
    }
  ],
  ["path", { d: "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05", key: "wn3emo" }]
], a1 = c("store", n1);
function j1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(S, {}) });
}
function v1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(C, {}) });
}
function f1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(B, {}) });
}
function g1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(w, {}) });
}
function t1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "-12.1 -12.1 174.2 174.2",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Avanti" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "m75,128.46c-29.53,0 -53.48,-23.94 -53.48,-53.48s23.94,-53.48 53.48,-53.48s53.48,23.94 53.48,53.48s-23.94,53.48 -53.48,53.48m0,-115.3c-34.1,0 -61.84,27.74 -61.84,61.84s27.74,61.84 61.84,61.84s61.84,-27.74 61.84,-61.84s-27.74,-61.84 -61.84,-61.84",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "m95.69,80.32s-3.75,-1.82 -5.13,-1.42c0,0 1.22,0.94 2.37,1.08c0,0 -1.28,1.31 -4.04,-0.18l-2.76,-1.49s5.32,-3.31 9.56,2.01m-7.27,27.35c-14.03,0 -10.83,-10.32 -7.85,-13.06c1.17,-2 12.71,-10.76 21.38,-2.61c0,0 4.24,-5.57 -2.18,-9.27c0,0 -0.68,-16.65 -29.66,-8.27c0,0 -0.3,-33.43 36.54,-31.76c0,0 -16.49,-13.23 -36.16,-0.9c0,0 -9.17,5.87 -12.4,16.15c0,0 -0.44,-19.86 18.2,-27.34c-11.51,-1.16 -21.21,4.36 -26.8,12.79c-4.58,7.42 -7.42,17.14 -1.83,30.92c0,0 -11.37,-8.74 -9.31,-22.89c-4.77,6.19 -6.78,13.54 -4.35,23.77c2.36,9.95 10.81,17.41 18.14,19.09c-5.22,0.98 -13.28,-0.03 -19.15,-8.3c0,0 8.13,33.19 42.72,33.19c27.32,-0.69 37.86,-21.24 37.86,-21.24c0,0 -11.12,9.72 -25.15,9.72",
            fill: e
          }
        )
      ]
    }
  );
}
function m1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(t1, { className: a.className, variant: a.variant }) });
}
function e1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Bergamont" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M20.2061 16.3771L24.6464 8.64578C24.8078 8.36128 24.6167 8 24.3068 8H15.7021C15.354 8 15.0271 8.19419 14.8446 8.5103L6.14645 23.6568C5.95118 24 5.95118 24.429 6.14645 24.7677L14.5984 39.4897C14.7809 39.8058 15.1035 40 15.4559 40H32.0923C32.4404 40 32.7673 39.8058 32.9498 39.4897L41.9281 23.851C42.0979 23.5574 41.9536 23.1691 41.6352 23.0833L20.4948 17.1448C20.1806 17.0545 20.0321 16.6706 20.2019 16.3726M12.1278 30.4443L14.9804 25.4767C15.1587 25.1696 15.5068 25.0206 15.8337 25.1109L35.7388 30.7017C35.9171 30.7513 35.8831 31.0313 35.7006 31.0313H12.4376C12.1532 31.0313 11.9792 30.7017 12.1278 30.4443Z",
            fill: e
          }
        )
      ]
    }
  );
}
function k1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(e1, { className: a.className, variant: a.variant }) });
}
function c1(a) {
  const e = (a.variant || "light") === "light" ? "#FAFAF9" : "#0C0A09";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 20 9",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Dolomite" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M19.2208 5.62313L11.1748 0.418819C10.2285 -0.193213 8.87345 -0.127929 8.02128 0.571827L0 7.16749H1.79599C2.22455 7.16749 2.63825 7.02672 2.94295 6.77783L9.25246 1.61432C9.48284 1.42663 9.847 1.40827 10.1022 1.57352L18.0268 6.69826C18.1581 6.78395 18.168 6.90431 18.1309 6.99C18.0962 7.07568 17.9971 7.16749 17.8286 7.16749H7.46142L10.9295 4.31134H9.08153C8.65049 4.31134 8.2368 4.45211 7.9321 4.70304L3.17581 8.62004H17.9599C18.8418 8.62004 19.5974 8.17734 19.8847 7.48982C20.1721 6.80435 19.912 6.06991 19.2184 5.62313H19.2208Z",
            fill: e
          }
        )
      ]
    }
  );
}
function y1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(c1, { className: a.className, variant: a.variant }) });
}
function s1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "-64.3 -47.76 329.37 329.37",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Granville" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M37.93,84.22L0,55.77l20.69,113.79c1.04,5.71,4.26,10.79,8.98,14.16l70.18,50.13L37.93,84.22h0Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "polygon",
          {
            fill: e,
            points: "100.38 233.21 154.06 85.89 100.38 0 46.7 85.89"
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M162.84,84.22l-61.92,149.63,70.18-50.12c4.72-3.37,7.94-8.45,8.98-14.16l20.69-113.79-37.93,28.45h0Z",
            fill: e
          }
        )
      ]
    }
  );
}
function L1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(s1, { className: a.className, variant: a.variant }) });
}
function l1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "-75.5 -75.5 718 718",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Malvern Star" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M410.88,283.52l73.1-99.83,20.22-27.6-34.05,3.73-122.89,13.36-49.95-113.23-13.77-31.3-13.8,31.3-49.94,113.19-122.92-13.45-34.06-3.76,20.24,27.62,73,99.88-73.06,99.84-20.25,27.6,34.06-3.74,122.93-13.36,49.86,113.25,13.76,31.29,13.81-31.27,50.03-113.23,122.86,13.45,34.06,3.76-20.2-27.62-73.02-99.88ZM381.21,332.18l9.85,13.48-16.6-1.83-59.92-6.57-24.39,55.21-6.73,15.26-6.73-15.26-24.31-55.22-59.94,6.51-16.6,1.82,9.86-13.47,35.64-48.67-35.59-48.7-9.87-13.47,16.6,1.82,59.94,6.57,24.37-55.21,6.72-15.25,6.72,15.26,24.35,55.22,59.93-6.51,16.61-1.82-9.86,13.47-35.66,48.67,35.61,48.69Z",
            fill: e
          }
        )
      ]
    }
  );
}
function w1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(
    l1,
    {
      className: a.className,
      variant: a.variant
    }
  ) });
}
function r1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "SCOTT" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M18.0633 21.2521C17.8719 20.9107 17.7587 20.5222 17.7587 20.1052C17.7587 19.6883 17.8649 19.3173 18.048 18.9799L21.0176 13.9917C21.0176 13.9917 21.1923 13.6018 21.761 13.228C22.3312 12.8543 23.002 12.8745 23.002 12.8745L30.3708 12.8772L34.4863 6H19.7822C18.4686 6.00675 17.3171 6.66249 16.6519 7.65285L11.1767 16.8576C10.4304 18.0759 10 19.494 10 21.0106C10 22.5272 10.4234 23.9237 11.1571 25.134V25.1407L17.0879 35.0052L20.6766 29.0576C21.2677 28.0079 21.2845 26.7369 20.7227 25.675L18.0633 21.2521Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M29.4659 26.7472C29.656 27.0886 29.7692 27.4812 29.7692 27.8954C29.7692 28.3097 29.663 28.6834 29.4799 29.0194L26.5117 34.0103C26.5117 34.0103 26.3356 34.3989 25.7654 34.7727C25.1967 35.1451 24.5245 35.1262 24.5245 35.1262L17.1571 35.1221L13.043 41.9993H27.747C29.0606 41.9926 30.2122 41.3355 30.8787 40.3465L36.354 31.1404C37.0988 29.922 37.5293 28.5067 37.5293 26.9874C37.5293 25.4681 37.1058 24.0757 36.3708 22.864V22.8586L30.4413 12.9941L26.8527 18.9417C26.2615 19.9901 26.2448 21.2624 26.8065 22.3243L29.4659 26.7459V26.7472Z",
            fill: e
          }
        )
      ]
    }
  );
}
function M1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(r1, { className: a.className, variant: a.variant }) });
}
function i1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "-22.67 -22.67 195.33 195.33",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Sheppard" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "m135.15201,104.93977c-13.20209,-16.04054 -36.56978,-22.93863 -36.6688,-22.93863c2.80544,-9.76955 5.90793,-28.87957 -3.66358,-49.37581c-13.99421,-30.03475 -29.96874,-21.65142 -39.96932,0.19803c0,0 -11.78286,23.3677 -3.43254,49.11177l0,0.09902s0,0 0,0c-2.57441,0.79213 -24.15982,7.78923 -36.56978,22.93863c-13.23509,16.07354 -8.28431,23.96179 -8.28431,23.96179c0,0 3.1685,7.92125 22.31153,7.92125c0,0 23.73075,0.99016 46.07529,-19.40707l0,0c22.37754,20.33122 46.1743,19.40707 46.1743,19.40707c19.14303,0 22.31153,-7.88825 22.31153,-7.88825c0,0 4.95078,-7.92125 -8.28431,-23.9948l0,-0.03301zm-75.68097,-56.96701c4.48871,-12.31095 10.1326,-18.51593 15.34743,-18.51593c6.17198,0 10.62768,6.27099 15.34743,18.51593c3.59757,9.37348 3.53156,21.05733 0.23104,32.2461c-0.69311,-0.16503 -13.96121,-3.1685 -31.18993,0l0,-0.06601s-4.35669,-19.5721 0.23104,-32.14709l0.03301,-0.03301zm-22.31153,77.99134s-28.38449,3.00348 -16.33758,-13.8952c12.24494,-17.19572 30.56283,-22.83961 32.90621,-23.49972l0.09902,0.19803c4.65374,9.37348 10.00058,16.93168 15.51245,23.00464c-15.97453,13.23509 -32.2131,14.19224 -32.2131,14.19224l0.03301,0zm37.75797,-19.6051c-4.91778,-5.11581 -9.63752,-11.55183 -13.59815,-19.67111c6.40301,-1.18819 16.27157,-2.24436 26.96527,-0.29705c-3.03648,7.49219 -7.52519,14.45629 -13.3011,20.06717l0,-0.09902l-0.06601,0zm37.923,19.6051s-16.20556,-1.05617 -32.18009,-14.29126c5.51187,-6.07296 10.79271,-13.59815 15.44644,-22.93863c0.29705,0.06601 20.10018,5.01679 33.10424,23.30169c12.04691,16.89867 -16.33758,13.8952 -16.33758,13.8952l-0.03301,0.03301z",
            fill: e
          }
        )
      ]
    }
  );
}
function p1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(i1, { className: a.className, variant: a.variant }) });
}
function o1(a) {
  const e = (a.variant || "light") === "light" ? "currentColor" : "#44403C";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 48 48",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "Syncros" }),
        /* @__PURE__ */ n.jsx(
          "mask",
          {
            height: "35",
            id: "mask0_5103_29816",
            maskUnits: "userSpaceOnUse",
            style: { maskType: "luminance" },
            width: "36",
            x: "6",
            y: "7",
            children: /* @__PURE__ */ n.jsx("path", { d: "M42 7H6V41.0935H42V7Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ n.jsxs("g", { mask: "url(#mask0_5103_29816)", children: [
          /* @__PURE__ */ n.jsx(
            "mask",
            {
              height: "35",
              id: "mask1_5103_29816",
              maskUnits: "userSpaceOnUse",
              style: { maskType: "luminance" },
              width: "36",
              x: "6",
              y: "7",
              children: /* @__PURE__ */ n.jsx("path", { d: "M42 7H6V41.0935H42V7Z", fill: "white" })
            }
          ),
          /* @__PURE__ */ n.jsxs("g", { mask: "url(#mask1_5103_29816)", children: [
            /* @__PURE__ */ n.jsx(
              "path",
              {
                d: "M30.493 10.9611C27.0338 10.1828 11.9409 7 11.9409 7L6 17.9238V32.6861C6 32.6861 13.359 19.0967 14.4682 17.1134C15.7192 14.885 17.4108 14.0106 19.4316 14.0106H35.2285C33.1469 12.1127 32.4631 11.409 30.4879 10.9611",
                fill: e
              }
            ),
            /* @__PURE__ */ n.jsx(
              "path",
              {
                d: "M17.5082 37.1312C20.9674 37.9096 36.0602 41.0924 36.0602 41.0924L42.0011 30.1686V15.4062C42.0011 15.4062 34.6421 28.9957 33.5278 30.9789C32.2769 33.2074 30.5852 34.0817 28.5644 34.0817H12.7676C14.8492 35.9797 15.5329 36.6834 17.5082 37.1312Z",
                fill: e
              }
            ),
            /* @__PURE__ */ n.jsx(
              "path",
              {
                d: "M31.8698 20.1039C31.176 21.3941 27.418 28.3568 26.8558 29.4017C26.3797 30.2867 25.8327 30.6919 24.445 30.6919H17.6785C15.4095 30.6919 15.3842 28.8952 15.7843 28.1008C16.2958 27.0826 20.5502 19.3895 20.9047 18.7018C21.4061 17.7315 22.4697 17.3477 23.3611 17.3477H29.4236C31.3735 17.3477 32.5637 18.7978 31.8648 20.1039",
                fill: e
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function N1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(o1, { className: a.className, variant: a.variant }) });
}
function H1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(d, {}) });
}
function I1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(p, {}) });
}
function S1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(i, {}) });
}
function _1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(x, {}) });
}
function B1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(u, {}) });
}
function V1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(H, {}) });
}
function A1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(o, {}) });
}
function F1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(D, {}) });
}
function Z1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(j, {}) });
}
function b1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(T, {}) });
}
function z1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(R, {}) });
}
function $1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(O, {}) });
}
function T1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx("svg", { fill: "none", viewBox: "0 0 22 18", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ n.jsx(
    "path",
    {
      d: "M13.1006 1.43457C14.562 0.413079 16.5085 0.198233 18.082 0.941406C19.6596 1.68666 20.8209 3.42234 20.873 5.25879C20.9234 7.0412 20.0204 8.73834 18.9277 10.2881C17.3285 12.5567 14.1268 15.5561 10.6875 17.4287C7.24825 15.5561 4.04642 12.5566 2.44727 10.2881C1.35461 8.73836 0.451595 7.04128 0.501953 5.25879C0.55375 3.42247 1.71572 1.68771 3.29297 0.942383C4.8669 0.19914 6.81335 0.413037 8.27441 1.43457C9.10322 2.0142 9.77665 2.84092 10.2373 3.79785L10.6875 4.73438L11.1387 3.79785C11.599 2.84091 12.2718 2.01416 13.1006 1.43457Z",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeWidth: "1.5"
    }
  ) }) });
}
function U1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(Z, {}) });
}
function D1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(W, {}) });
}
function P1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(h, {}) });
}
function R1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(A, {}) });
}
function q1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(z, {}) });
}
function O1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(E, {}) });
}
function G1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(Y, {}) });
}
function W1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(v, {}) });
}
function X1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(J, {}) });
}
function h1(a) {
  const e = (a.variant || "light") === "light" ? "#FAFAF9" : "#0C0A09";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 18 19",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "SCOTT Bike" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M3.80437 7.25211C3.71816 7.08979 3.66719 6.90503 3.66719 6.70679C3.66719 6.50855 3.71501 6.33212 3.79745 6.17173L5.13461 3.79991C5.13461 3.79991 5.21327 3.6145 5.46938 3.43679C5.72612 3.25908 6.02816 3.26871 6.02816 3.26871L9.34623 3.26999L11.1994 0H4.57835C3.98685 0.00320776 3.46834 0.315002 3.16882 0.785901L0.703392 5.16257C0.36737 5.74189 0.173559 6.41616 0.173559 7.13727C0.173559 7.85837 0.364223 8.52238 0.694583 9.09785V9.10106L3.36515 13.7914L4.98108 10.9635C5.24725 10.4644 5.2548 9.86002 5.00184 9.35511L3.805 7.25211H3.80437Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M8.93861 9.86498C9.02419 10.0273 9.07516 10.214 9.07516 10.4109C9.07516 10.6079 9.02733 10.7856 8.9449 10.9454L7.60836 13.3185C7.60836 13.3185 7.52907 13.5032 7.27234 13.6809C7.01623 13.858 6.71356 13.849 6.71356 13.849L3.39612 13.8471L1.54359 17.1171H8.16462C8.75613 17.1139 9.27463 16.8014 9.57479 16.3312L12.0402 11.9539C12.3756 11.3746 12.5694 10.7016 12.5694 9.97918C12.5694 9.25679 12.3788 8.59471 12.0478 8.01859V8.01603L9.37783 3.32564L7.7619 6.1536C7.49572 6.65209 7.48817 7.25707 7.74114 7.76197L8.93861 9.86434V9.86498Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "circle",
          {
            cx: "12.3217",
            cy: "13.4619",
            fill: "#FAFAF9",
            r: "5.03814",
            stroke: "#0C0A09",
            strokeWidth: "1"
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M10.3471 15.9792V11.0593H12.7365C13.1407 11.0593 13.4578 11.1744 13.6881 11.4047C13.9183 11.6349 14.0335 11.9404 14.0335 12.321C14.0335 12.57 13.9912 12.7721 13.9066 12.9272C13.8267 13.0775 13.7163 13.188 13.5753 13.2585C13.439 13.3289 13.2863 13.3689 13.1172 13.3783V13.4206C13.2346 13.4206 13.3568 13.4417 13.4837 13.484C13.6106 13.5263 13.7304 13.5921 13.8432 13.6814C13.9559 13.7707 14.0476 13.8905 14.1181 14.0408C14.1885 14.1865 14.2238 14.3651 14.2238 14.5765C14.2238 14.835 14.1674 15.0699 14.0546 15.2814C13.9465 15.4928 13.7962 15.662 13.6035 15.7889C13.4155 15.9158 13.1994 15.9792 12.955 15.9792H10.3471ZM11.4185 13.9492V15.077H12.652C12.7459 15.077 12.8258 15.0605 12.8916 15.0276C12.9621 14.99 13.0161 14.9384 13.0537 14.8726C13.0913 14.8068 13.1101 14.7269 13.1101 14.6329V14.3933C13.1101 14.2993 13.0913 14.2194 13.0537 14.1536C13.0161 14.0878 12.9621 14.0385 12.8916 14.0056C12.8258 13.968 12.7459 13.9492 12.652 13.9492H11.4185ZM11.4185 11.9615V13.0752H12.4828C12.5768 13.0752 12.6567 13.0587 12.7224 13.0259C12.7929 12.9883 12.8446 12.9366 12.8775 12.8708C12.9151 12.8003 12.9339 12.7181 12.9339 12.6241V12.4126C12.9339 12.3186 12.9151 12.2388 12.8775 12.173C12.8446 12.1025 12.7929 12.0508 12.7224 12.0179C12.6567 11.9803 12.5768 11.9615 12.4828 11.9615H11.4185Z",
            fill: "#0C0A09"
          }
        )
      ]
    }
  );
}
function E1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(h1, { className: a.className, variant: a.variant }) });
}
function C1(a) {
  const s = a.variant || "light", e = s === "light" ? "#FAFAF9" : "#0C0A09", l = s === "light" ? "#44403C" : "#0C0A09", r = s === "light" ? "#44403C" : "#FAFAF9";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 18 19",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "SCOTT Running" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M3.80437 7.25211C3.71816 7.08979 3.66719 6.90503 3.66719 6.70679C3.66719 6.50855 3.71501 6.33212 3.79745 6.17173L5.13461 3.79991C5.13461 3.79991 5.21327 3.6145 5.46938 3.43679C5.72612 3.25908 6.02816 3.26871 6.02816 3.26871L9.34623 3.26999L11.1994 0H4.57835C3.98685 0.00320776 3.46834 0.315002 3.16882 0.785901L0.703392 5.16257C0.36737 5.74189 0.173559 6.41616 0.173559 7.13727C0.173559 7.85837 0.364223 8.52238 0.694583 9.09785V9.10106L3.36515 13.7914L4.98108 10.9635C5.24725 10.4644 5.2548 9.86002 5.00184 9.35511L3.805 7.25211H3.80437Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M8.93861 9.86498C9.02419 10.0273 9.07516 10.214 9.07516 10.4109C9.07516 10.6079 9.02733 10.7856 8.9449 10.9454L7.60836 13.3185C7.60836 13.3185 7.52907 13.5032 7.27234 13.6809C7.01623 13.858 6.71356 13.849 6.71356 13.849L3.39612 13.8471L1.54359 17.1171H8.16462C8.75613 17.1139 9.27463 16.8014 9.57479 16.3312L12.0402 11.9539C12.3756 11.3746 12.5694 10.7016 12.5694 9.97918C12.5694 9.25679 12.3788 8.59471 12.0478 8.01859V8.01603L9.37783 3.32564L7.7619 6.1536C7.49572 6.65209 7.48817 7.25707 7.74114 7.76197L8.93861 9.86434V9.86498Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "circle",
          {
            cx: "12.3217",
            cy: "13.4619",
            fill: e,
            r: "5.03814",
            stroke: l
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M11.4185 14.1748V15.9792H10.3471V11.0593H12.6801C12.9856 11.0593 13.2487 11.1251 13.4696 11.2567C13.6904 11.3882 13.862 11.5715 13.9841 11.8065C14.1063 12.0414 14.1674 12.3163 14.1674 12.6311C14.1674 12.9601 14.0922 13.2514 13.9418 13.5052C13.7962 13.7542 13.573 13.9351 13.2722 14.0479L14.2379 15.9792H13.0467L12.1868 14.1748H11.4185ZM11.4185 13.2726H12.5462C12.6543 13.2726 12.7459 13.2538 12.8211 13.2162C12.8963 13.1786 12.955 13.1245 12.9973 13.054C13.0396 12.9789 13.0608 12.8896 13.0608 12.7862V12.4761C13.0608 12.368 13.0396 12.2787 12.9973 12.2082C12.955 12.1377 12.8963 12.0837 12.8211 12.0461C12.7459 12.0085 12.6543 11.9897 12.5462 11.9897H11.4185V13.2726Z",
            fill: r
          }
        )
      ]
    }
  );
}
function Q1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(C1, { className: a.className, variant: a.variant }) });
}
function d1(a) {
  const s = a.variant || "light", e = s === "light" ? "#FAFAF9" : "#0C0A09", l = s === "light" ? "#44403C" : "#0C0A09", r = s === "light" ? "#44403C" : "#FAFAF9";
  return /* @__PURE__ */ n.jsxs(
    "svg",
    {
      className: a.className,
      fill: "none",
      role: "img",
      viewBox: "0 0 18 19",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n.jsx("title", { children: "SCOTT Winter" }),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M3.80437 7.25211C3.71816 7.08979 3.66719 6.90503 3.66719 6.70679C3.66719 6.50855 3.71501 6.33212 3.79745 6.17173L5.13461 3.79991C5.13461 3.79991 5.21327 3.6145 5.46938 3.43679C5.72612 3.25908 6.02816 3.26871 6.02816 3.26871L9.34623 3.26999L11.1994 0H4.57835C3.98685 0.00320776 3.46834 0.315002 3.16882 0.785901L0.703392 5.16257C0.36737 5.74189 0.173559 6.41616 0.173559 7.13727C0.173559 7.85837 0.364223 8.52238 0.694583 9.09785V9.10106L3.36515 13.7914L4.98108 10.9635C5.24725 10.4644 5.2548 9.86002 5.00184 9.35511L3.805 7.25211H3.80437Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M8.93861 9.86498C9.02419 10.0273 9.07516 10.214 9.07516 10.4109C9.07516 10.6079 9.02733 10.7856 8.9449 10.9454L7.60836 13.3185C7.60836 13.3185 7.52907 13.5032 7.27234 13.6809C7.01623 13.858 6.71356 13.849 6.71356 13.849L3.39612 13.8471L1.54359 17.1171H8.16462C8.75613 17.1139 9.27463 16.8014 9.57479 16.3312L12.0402 11.9539C12.3756 11.3746 12.5694 10.7016 12.5694 9.97918C12.5694 9.25679 12.3788 8.59471 12.0478 8.01859V8.01603L9.37783 3.32564L7.7619 6.1536C7.49572 6.65209 7.48817 7.25707 7.74114 7.76197L8.93861 9.86434V9.86498Z",
            fill: e
          }
        ),
        /* @__PURE__ */ n.jsx(
          "circle",
          {
            cx: "12.3217",
            cy: "13.4619",
            fill: e,
            r: "5.03814",
            stroke: l
          }
        ),
        /* @__PURE__ */ n.jsx(
          "path",
          {
            d: "M10.1155 15.9792L9.00181 11.0593H10.0591L10.5243 13.4206L10.7851 14.788H10.8062L11.1164 13.4206L11.6591 11.0593H12.8292L13.379 13.4206L13.682 14.788H13.7032L13.964 13.4206L14.4362 11.0593H15.4512L14.3094 15.9792H13.09L12.4697 13.3148L12.23 12.2364H12.2089L11.9622 13.3148L11.3419 15.9792H10.1155Z",
            fill: r
          }
        )
      ]
    }
  );
}
function J1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(d1, { className: a.className, variant: a.variant }) });
}
function K1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(h, {}) });
}
function Y1(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(f, {}) });
}
function n2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(a1, {}) });
}
function a2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(i, {}) });
}
function t2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(g, {}) });
}
function e2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(m, {}) });
}
function c2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(k, {}) });
}
function s2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(y, {}) });
}
function l2(a) {
  return /* @__PURE__ */ n.jsx(t, { ...a, children: /* @__PURE__ */ n.jsx(o, {}) });
}
export {
  O1 as A,
  G1 as B,
  W1 as C,
  X1 as D,
  E1 as E,
  M1 as F,
  Q1 as G,
  J1 as H,
  j1 as I,
  K1 as J,
  p1 as K,
  Y1 as L,
  n2 as M,
  N1 as N,
  a2 as O,
  t2 as P,
  e2 as Q,
  c2 as R,
  s2 as S,
  l2 as T,
  v1 as a,
  f1 as b,
  m1 as c,
  g1 as d,
  k1 as e,
  H1 as f,
  I1 as g,
  S1 as h,
  _1 as i,
  B1 as j,
  V1 as k,
  A1 as l,
  F1 as m,
  y1 as n,
  Z1 as o,
  b1 as p,
  z1 as q,
  $1 as r,
  L1 as s,
  T1 as t,
  U1 as u,
  D1 as v,
  P1 as w,
  w1 as x,
  R1 as y,
  q1 as z
};
